import { axios } from "utilities/axios";
import { IInteractionsGetQueryParameters, IInteractionsGetResponse, Route } from "@edgetier/watchtower-types";

/**
 * Request interactions according to some parameters.
 * @param url  Optional next page URL.
 * @returns    Interactions data.
 */
export const getInteractions = async (parameters: IInteractionsGetQueryParameters, url: string | undefined) => {
    const request =
        typeof url === "string"
            ? axios.get<IInteractionsGetResponse>(url)
            : axios.get<IInteractionsGetResponse>(Route.Interactions, { params: parameters });
    const response = await request;
    return response.data;
};
